// by entity it means Accounts or Risks

export default (oldState, data, matchTo) => {
	const newData = oldState.map((item) => {
		const findMatching = (i) => item[matchTo] === i[matchTo];

		if (data.some(findMatching)) return {...item, ...data.find(findMatching)};

		return {...item};
	});

	return newData;
};
